import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function CTAButton({
  text = 'QUIERO ABUNDANCIA & DINERO',
  onClick,
  className = '',
  variant = 'primary',
  fullWidth = false
}: CTAButtonProps) {
  const baseStyles = 'group relative px-8 py-4 bg-[#d4af37] text-[#0f4c3a] font-bold text-lg transition-all duration-300 hover:bg-[#c49d2f] hover:shadow-2xl overflow-hidden rounded-[12px]';
  const variants = {
    primary: 'bg-[#d4af37] text-[#0f4c3a] hover:bg-[#c5a028] shadow-lg hover:shadow-xl',
    secondary: 'bg-[#0f4c3a] text-[#d4af37] hover:bg-[#0a382b] shadow-lg hover:shadow-xl',
    outline: 'border-2 border-[#0f4c3a] text-[#0f4c3a] hover:bg-[#0f4c3a] hover:text-[#d4af37]'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-232">
      <span className="relative z-10 flex items-center gap-2 font-serif" data-id="element-233">
        {text}
        <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-234" />
      </span>

      {/* Shine effect overlay */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0" data-id="element-235" />
    </motion.button>;
}